import React from 'react'

import type { useInternalState } from './hooks/useInternalState'

type Internals = ReturnType<typeof useInternalState>

export type InterviewsCreatorState = Internals['state']
export type InterviewsCreatorHandlers = Internals['handlers']

export const InterviewsCreatorHandlersContext = React.createContext<
  InterviewsCreatorHandlers | undefined
>(undefined)
export const InterviewsCreatorStateContext = React.createContext<
  InterviewsCreatorState | undefined
>(undefined)
